module.exports = __webpack_public_path__ + "static/media/ishuhui.e9c2c9f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/ishuhui.png
// module id = 121
// module chunks = 0